import { Gender } from '@massilia/prisma-generated/enums';
import { z } from 'zod';
import { isoDateString } from '../_shared/dates.js';
import { personName } from '../_shared/person-name.js';
export const createPassengerSchema = z.object({
    firstName: personName(),
    lastName: personName(),
    birthDate: isoDateString(),
    gender: z.nativeEnum(Gender),
    nationalityCode: z.string().min(2),
});
export const updatePassengerSchema = z.object({
    firstName: personName({ optional: true }),
    lastName: personName({ optional: true }),
    birthDate: isoDateString().optional(),
    gender: z.nativeEnum(Gender).optional(),
    nationalityCode: z.string().min(2).optional(),
});
